import React from 'react'

const AbtAbout = () => {
  return (
    <>
    <section className="about-area pt-110">
            <div className="container">
                <div className="section-title mb-55">
                    <span className="sub-title wow fadeInRight" data-wow-duration=".7s">About Om Softwares</span>
                    <h3 className="title xb-split-text split-in-right mb-35">Crafting Digital <br/> <span>Excellence</span></h3>
                    <p className="section-content">At Om Softwares, we specialize in delivering cutting-edge digital solutions tailored to meet the unique needs of businesses. Based in Nangal, we are passionate about empowering organizations with innovative technology and creative strategies.

                        Our expertise spans website design, software development, mobile app creation, graphic design, UI/UX design, and digital marketing. With a customer-first approach, we blend creativity, functionality, and the latest trends to help our clients achieve their goals.
                        
                        We pride ourselves on offering reliable and cost-effective services, whether you're a startup, small business, or enterprise. At Om Softwares, we don't just build solutions—we build partnerships for success.
                        
                        Join us in shaping the digital future. Together, let's make your vision a reality.</p>
                </div>
                <div className="about-img pos-rel">
                    <img src="assets/img/about/about-main.webp" alt=""/>
                    <div className="about-year">
                        <h2 className="xb-odm"><span className="xbo" data-count="5">00</span></h2>
                        <p>Year of <br/>Experience</p>
                    </div>
                </div>
                <div className="row mt-50">
                    <div className="col-xl-8 offset-xl-4">
                        
                        <div className="row mt-none-30">
                            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mt-30">
                                <div className="xb-funfact text-center">
                                    <h3 className="xb-item--number xb-odm"><span className="xbo"
                                            data-count="345">00</span><span className="suffix">+</span></h3>
                                    <h6 className="xb-item--title">Projects Delivered</h6>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mt-30">
                                <div className="xb-funfact text-center">
                                    <h3 className="xb-item--number xb-odm"><span className="xbo" data-count="12">00</span>
                                    </h3>
                                    <h6 className="xb-item--title">Team Members</h6>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mt-30">
                                <div className="xb-funfact text-center">
                                    <h3 className="xb-item--number xb-odm">
                                        <span className="xbo" data-count="35">00</span>
                                        <span className="suffix">+</span>
                                    </h3>
                                    <h6 className="xb-item--title">Social Media Accounts Managed</h6>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mt-30">
                                <div className="xb-funfact text-center">
                                    <h3 className="xb-item--number xb-odm">
                                        <span className="xbo" data-count="02">00</span>
                                        <span className="suffix">million</span>
                                    </h3>
                                    <h6 className="xb-item--title">Influencer Reach Network</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default AbtAbout
